module.exports = __webpack_public_path__ + "static/media/Image.96d9aaf8.png";